import React, { createContext, useContext, useState, useEffect } from 'react';
import airportsData from '../data/airports.json';

const AirportsContext = createContext();

export function AirportsProvider({ children }) {
  const [airports, setAirports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Load airports from local JSON file
    setLoading(true);
    setAirports(airportsData);
    setLoading(false);
  }, []);

  const filterAirports = (query, limit = 8) => {
    if (!query || query.length < 2) {
      return [];
    }

    const upperQuery = query.toUpperCase();

    // Filter by IATA code only - match codes that START with the query
    return airports
      .filter(airport => airport.iata_code && airport.iata_code.toUpperCase().startsWith(upperQuery))
      .slice(0, limit);
  };

  return (
    <AirportsContext.Provider value={{ airports, loading, error, filterAirports }}>
      {children}
    </AirportsContext.Provider>
  );
}

export function useAirports() {
  const context = useContext(AirportsContext);
  if (!context) {
    throw new Error('useAirports must be used within an AirportsProvider');
  }
  return context;
}
